<script>
	import { createEventDispatcher } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		cabecalhoPadraoRequisicao,
		API, 
		TextoFeedback } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let tipoDistribuicao, senha, captchaUsuario;
	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let nivelAvaliacao;

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Distribuindo ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {
			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('distribuicao'), {
				method: 'POST',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					senha: senha,
					nivelAvaliacao: nivelAvaliacao,
					tipoObjetoDistribuido: tipoDistribuicao
				})
			}).catch(erros => {
				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.OK) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: json?.mensagem
				});

				replace('/painel/distribuicao');
			} else if (resposta.status == StatusHttp.UNPROCESSABLE_ENTITY) {
				tituloAviso = 'Verifique os dados informados!'
				feedbackUsuario.push(json?.mensagem);
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}

	}
</script>

<TBox 
	titulo="Confirmação de Distribuição" 
	subtitulo="Informe os dados abaixo para prosseguir" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="distribuicao">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<p class="is-size-4">Selecione o tipo de distribuição a ser executada: </p>
		
		<div class="select is-primary is-large is-fullwidth">
			<select bind:value={tipoDistribuicao} name="tipoDistribuicao" required>
				<option value="">Selecione ...</option>
				<option value="APRESENTACAO">Apresentação (semana de graduação)</option>
				<option value="PROJETO">Projeto</option>
			</select>
		</div>
		<hr>

		<div class="columns">
			<div class="column is-7">
				<p>Informe ao lado o nível de avaliação para cada projeto/apresentação, podendo ser avaliação única ou dupla. Em uma dupla avaliação, cada projeto/apresentação será avaliado por dois avaliadores, a pontuação final será o somatório das pontuações divido pela quantidade de avaliadores envolvidos.</p>
			</div>
			<div class="column is-5">
				<p class="mb-3"><strong>Nível da AVALIAÇÃO:</strong></p>

				<div class="control is-size-5">
					<label class="radio">
						<input type="radio" bind:group={nivelAvaliacao} name="nivelAvaliacao" value="UNICA"> Avaliação única
					</label>
					<br>
					<label class="radio">
						<input type="radio" bind:group={nivelAvaliacao} name="nivelAvaliacao" value="DUPLA"> Avaliação dupla
					</label>
				</div>				
			</div>
		</div>

		<div class="columns">
			<div class="column is-full">
				<div class="field">
					<input 
						bind:value={senha}
						name="senha" 
						type="password" 
						placeholder="Informe sua senha" 
						class="input is-large is-primary" required>
				</div>
			</div>
		</div>

		<div class="columns is-mobile">
			<div class="column">
				<Captcha />
			</div>
			<div class="column">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/painel/distribuicao" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-8">
				<p class="control">
					<button 
						type="submit" 
						class="button is-danger is-medium is-fullwidth">
						Executar
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>